// import React, { useState, useEffect, useRef } from "react";
// import css from "../css/gamehis.module.css";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import ReactPaginate from "react-paginate";
// import axios from "axios";
// import Invoice from "./Invoice";
// import { AiOutlineDownload } from "react-icons/ai";
// import "./invoice.css";
// import socket from "../Components/socket";
// import { BsFillEyeFill } from "react-icons/bs";
// import Refer from "./Refer";
// import Gamehistory from "./Gamehistory";
// import Referralhis from "./Referralhis";
// import "../../app2.js/css/landing.css";
// import Transactionhistory from "./Transactionhistory";
// import allHistory from "./Gamehistory";
// import { apiRequest } from "../../apiService/allApi";

// const Newhistory = () => {
//   const [show, setShow] = useState(false);
//   const [invoiceData, setInvoiceData] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [user, setUser] = useState();

//   // BASE URL

//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const nodeMode = process.env.NODE_ENV;
//   if (nodeMode === "development") {

//     var baseUrl = beckendLocalApiUrl;
//   } else {
//     baseUrl = beckendLiveApiUrl;
//   }
//   // +++++++++++++++++++++++++++++

//   const handleClose = () => setShow(false);
//   const handleShow = (e) => {
//     setShow(true);
//     setInvoiceData(e);
//   };

//   const [cardData, setCardData] = useState()

//   const role = async () => {
//     socket.emit("getprofile");

//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     // await axios
//     //   .get(baseUrl+`me`, { headers })

//     const res = await apiRequest(`me`, "GET", null, headers)

//     // .then((res) => {
//     setUser(res.data);
//     if (res.data) {
//       allHistory(res?.data?.id);
//     }
//     // });
//   };

//   const [allHistoryData, setAllHistoryData] = useState();
//   // console.log(allHistoryData);

//   const allHistory = async (id) => {
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };
//     setIsLoading(true);
//     {

//     }
//     // await axios
//     //   .get(baseUrl+`txn_history/user/${id}`, {
//     //     headers,
//     //   })

//     const res = await apiRequest(`txn_history/user/${id}`, "GET", null, headers)
//     // .then((res) => {
//     // console.log(res.data)
//     setCardData(res.data);

//     // });
//   };

//   useEffect(() => {
//     role();
//   }, []);

//   const dateFormat = e => {
//     const date = new Date(e)
//     const newDate = date.toLocaleString('default', {
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       hour12: true,
//       minute: 'numeric'
//     })
//     return newDate
//   }

//   // change theme
//   const theme = localStorage.getItem('theme')

//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e2fc' : 'black',
//     color: theme === 'light' ? 'black' : '#fff',
//   };

//   return (
//     <>
//       <div className="leftContainer mb_space" style={{ ...styles, height: "100vh" }}>
//         <div className="  Orher_page_main_section" style={{ ...styles, height: "auto" }}>
//           <section className="transaction_main_section_modal">
//             <div className="">
//               <h2 className="text-center mt-4 animated-text"> History</h2>

//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 {/* <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link tabs"
//                     id="informative-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#informative"
//                     type="button"
//                     role="tab"
//                     aria-controls="informative"
//                     aria-selected="false"
//                   >
//                     All
//                   </button>
//                 </li> */}
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active tabs"
//                     id="game-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#game"
//                     type="button"
//                     role="tab"
//                     aria-controls="game"
//                     aria-selected="true"
//                   >
//                     game
//                   </button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link mx-3"
//                     id="transaction-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#transaction"
//                     type="button"
//                     role="tab"
//                     aria-controls="transaction"
//                     aria-selected="false"
//                   >
//                     transaction
//                   </button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                   <button
//                   style={{marginRight:'0'}}
//                     className="nav-link mr-0"
//                     id="others-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#others"
//                     type="button"
//                     role="tab"
//                     aria-controls="others"
//                     aria-selected="false"
//                     onClick={Refer}
//                   >
//                     Referral
//                   </button>
//                 </li>
//               </ul>

//               <div className="tab-content" id="myTabContent">
//                 <div
//                   className="tab-pane fade"
//                   id="informative"
//                   role="tabpanel"
//                   aria-labelledby="informative-tab"
//                 >
//                   {cardData &&
//                     cardData.map((card) => {
//                       var id = card?._id.toString(),
//                         ctr = 0;
//                       var timestamp = id.slice(ctr, (ctr += 8));
//                       var machineID = id.slice(ctr, (ctr += 6));
//                       var processID = id.slice(ctr, (ctr += 4));
//                       var counter = id.slice(ctr, (ctr += 6));

//                       var counterid = parseInt(timestamp, 16);

//                       if (
//                         (card?.Req_type === "deposit" || card?.Req_type === "bonus") &&
//                         card?.status != "FAILED"
//                       ) {
//                         var titleMsg = "Cash added";
//                         if (
//                           card?.status === "Pending" &&
//                           card?.Req_type === "deposit"
//                         ) {
//                           var signIcon = <div className="text-danger">(X)</div>;
//                         } else {
//                           var signIcon = <div className="text-success">(+)</div>;
//                         }
//                       } else if (
//                         card?.Req_type === "withdraw" &&
//                         card?.status != "FAILED"
//                       ) {
//                         var titleMsg = "Witdraw using " + card?.Withdraw_type;
//                         var signIcon = <div className="text-danger">(-)</div>;
//                       } else if (
//                         card?.Req_type === "penalty" &&
//                         card?.status != "FAILED"
//                       ) {
//                         var titleMsg = "Penalty";
//                         var signIcon = <div className="text-danger">(-)</div>;
//                       } else if (
//                         card?.status === "Pending" ||
//                         card?.status === "FAILED"
//                       ) {
//                         var titleMsg = "FAILED";
//                         var signIcon = <div className="text-danger">(X)</div>;
//                       } else {
//                         var titleMsg = "";
//                         var signIcon = <div className="text-success"></div>;
//                       }

//                       return (
//                         <>
//                           <div className="other_pages_card_main">
//                             <div>
//                               <h3>{titleMsg}</h3>
//                               <h3>
//                                 Order ID:{" "}
//                                 <span className="dark_light_color"> {counterid}</span>
//                               </h3>
//                               <p>
//                                 Status:
//                                 <span className="dark_light_color">
//                                   {card?.status === "none" ||
//                                     (card?.status === "Pending" &&
//                                       card?.Req_type === "withdraw")
//                                     ? "Processing"
//                                     : card?.status === "Pending" &&
//                                       card?.Req_type === "deposit"
//                                       ? "Cancelled"
//                                       : card?.status}
//                                 </span>
//                               </p>
//                               <p className="dander_text transaction_msg">
//                                 {card?.txn_msg ? card?.txn_msg : ""}
//                               </p>
//                             </div>

//                             <div className="transaction_right_side_main">
//                               <div className="card_rupee d-flex float-right">
//                                 {signIcon}
//                                 <picture className="">
//                                   <img
//                                     alt="img"
//                                     height="21px"
//                                     width="21px"
//                                     src={process.env.PUBLIC_URL + "/images/rupee.png"}
//                                     className="snip-img"
//                                   />
//                                 </picture>
//                                 <span className="pl-1">{card?.amount}</span>
//                               </div>
//                               <div>
//                                 {card?.closing_balance && (
//                                   <div
//                                     className={`${css.games_section_headline}`}
//                                     style={{
//                                       fontSize: "0.8em",
//                                       whiteSpace: "nowrap",
//                                     }}
//                                   >
//                                     closing balance :{card?.closing_balance}
//                                   </div>
//                                 )}
//                               </div>
//                               <div className="card_date">
//                                 <p>{dateFormat(card?.createdAt).split(",")[0]}</p>
//                                 <p>{dateFormat(card?.createdAt).split(",")[1]}</p>
//                               </div>
//                             </div>
//                           </div>
//                         </>
//                       );
//                     })}
//                 </div>

//                 <div
//                   className="tab-pane fade show active"
//                   id="game"
//                   role="tabpanel"
//                   aria-labelledby="game-tab"
//                 >
//                   <Gamehistory />
//                 </div>

//                 <div
//                   className="tab-pane fade"
//                   id="transaction"
//                   role="tabpanel"
//                   aria-labelledby="transaction-tab"
//                 >
//                   <Transactionhistory />
//                 </div>

//                 <div
//                   className="tab-pane fade"
//                   id="others"
//                   role="tabpanel"
//                   aria-labelledby="others-tab"
//                 >
//                   <Referralhis />
//                 </div>
//               </div>
//             </div>
//           </section>

//         </div>
//       </div>
//     </>
//   );
// };

// export default Newhistory;

// import React, { useState, useEffect, useRef } from "react";
// import css from "../css/gamehis.module.css";
// import ReactPaginate from "react-paginate";
// import axios from "axios";
// import socket from "../Components/socket";
// import Rightcontainer from "../Components/Rightcontainer";
// import { BsFillEyeFill } from "react-icons/bs";
// import { apiRequest } from "../../apiService/allApi";
// import { toast } from "react-toastify";

// const Newhistory = ({ TicketList, Conversation }) => {
//   // BASE URL
//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const nodeMode = process.env.NODE_ENV;
//   var baseUrl =
//     nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

//   const [user, setUser] = useState(null);
//   const [activeTab, setActiveTab] = useState("Wallet"); // 'Wallet', 'Game', 'Penalty', 'Bonus'

//   let limit = 50;
//   const [pageNumber, setPageNumber] = useState(0);
//   const [numberOfPages, setNumberOfPages] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);

//   // Data states
//   const [walletData, setWalletData] = useState([]);
//   const [gameData, setGameData] = useState([]);
//   const [selectedCardId, setSelectedCardId] = useState(null);

//   // Fetch User & Data
//   const role = async () => {
//     socket.emit("getprofile");
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await apiRequest(`me`, "GET", null, headers);
//       setUser(res.data);
//       fetchAllData(res.data._id);
//     } catch (e) {
//       setIsLoading(false);
//     }
//   };

//   const fetchAllData = async (userId) => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     setIsLoading(true);
//     try {
//       // 1. Fetch Wallet / Deposit / Withdraw / Transactions
//       const resWallet = await apiRequest(
//         `temp/deposite/${userId}?page=${pageNumber}&_limit=${limit}`,
//         "GET",
//         null,
//         headers,
//       );
//       if (resWallet?.data) {
//         setWalletData(resWallet.data.ress || []);
//         setNumberOfPages(resWallet.data.totalPages || 0);
//       }

//       // 2. Fetch Game History
//       const resGame = await apiRequest(
//         `game/history/user/${userId}?page=${pageNumber}&_limit=${limit}`,
//         "GET",
//         null,
//         headers,
//       );
//       if (resGame?.data?.data) {
//         let gameHis = [];
//         resGame.data.data.forEach((ele) => {
//           if (
//             ele.Status === "completed" ||
//             ele.Status === "cancelled" ||
//             ele.Status === "conflict"
//           ) {
//             gameHis.push(ele);
//           }
//         });
//         setGameData(gameHis);
//       }
//     } catch (e) {
//       console.log(e);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     role();
//     //eslint-disable-next-line
//   }, [pageNumber]);

//   const dateFormat = (e) => {
//     if (!e) return "";
//     const date = new Date(e);
//     const newDate = date.toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//     });
//     const time = date
//       .toLocaleTimeString("en-US", {
//         hour: "numeric",
//         minute: "numeric",
//         hour12: true,
//       })
//       .toLowerCase();
//     return `${newDate}, ${time}`;
//   };

//   // Filter Data based on Active Tab
//   const getFilteredData = () => {
//     if (activeTab === "Wallet") {
//       return walletData.filter(
//         (card) => card?.Req_type === "deposit" || card?.Req_type === "withdraw",
//       );
//     } else if (activeTab === "Game") {
//       return gameData;
//     } else if (activeTab === "Penalty") {
//       return walletData.filter((card) => card?.Req_type === "penalty");
//     } else if (activeTab === "Bonus") {
//       return walletData.filter((card) => card?.Req_type === "bonus");
//     }
//     return [];
//   };

//   const currentList = getFilteredData();

//   // Change Theme
//   const theme = localStorage.getItem("theme");
//   const styles = {
//     backgroundColor: theme === "light" ? "#d3e2fc" : "black",
//     color: theme === "light" ? "black" : "#fff",
//   };

//   return (
//     <div>
//       <div
//         className="leftContainer mt-5 pt-5 bgbox"
//         style={{ ...styles, paddingTop: "0px" }}
//       >
//          <h2 className="text-center mt-4 animated-text"> History</h2>
//         {/* TABS HEADER SECTION (As shown in screenshot) */}
//         <div
//           style={{
//             display: "flex",
//             gap: "10px",
//             padding: "15px",
//             overflowX: "auto",
//           }}
//         >
         

//           {["Wallet", "Game", "Penalty", "Bonus"].map((tab) => (
//             <button
//               key={tab}
//               onClick={() => setActiveTab(tab)}
//               style={{
//                 padding: "8px 24px",
//                 borderRadius: "30px",
//                 border: "1px solid #ccc",
//                 backgroundColor: activeTab === tab ? "black" : "white",
//                 color: activeTab === tab ? "white" : "black",
//                 fontWeight: "600",
//                 cursor: "pointer",
//                 outline: "none",
//                 boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//               }}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>

//         <div
//           className="Orher_page_main_section bgbox"
//           style={{
//             ...styles,
//             paddingBottom: "10vh !important",
//             padding: "15px",
//           }}
//         >
//           {isLoading ? (
//             <div className="text-center">
//               <div className="loaderReturn" style={{ zIndex: "99" }}>
//                 <img
//                   src={"/images/LandingPage_img/loader1.gif"}
//                   style={{ width: "100%" }}
//                   alt="loading"
//                 />
//               </div>
//             </div>
//           ) : currentList.length === 0 ? (
//             <div className="text-center not_found_box_main mt-4">
//               <img
//                 src="./images/not-found.gif"
//                 alt="no data"
//                 style={{ width: "120px" }}
//               />
//               <div className="mt-2">
//                 <h3 className="font-weight-bold">No {activeTab} History</h3>
//                 <p>You have no {activeTab.toLowerCase()} history yet.</p>
//               </div>
//             </div>
//           ) : (
//             currentList.map((card, index) => {
//               // Determine if it's a Wallet card or Game card
//               const isGameCard = activeTab === "Game";

//               let typeText = "";
//               let statusText = "";
//               let msgText = "";
//               let amountVal = "";
//               let isPositive = false;
//               let closingBal = "";
//               let dateStr = "";

//               if (isGameCard) {
//                 const isWin =
//                   card?.Status === "completed" &&
//                   card?.Winner &&
//                   card?.Winner?._id === user?._id;
//                 typeText = `Game: ${card?.Room_code || "Room"}`;
//                 statusText = isWin ? "SUCCESS" : card?.Status?.toUpperCase();
//                 msgText = `Game is ${isWin ? "Win" : "Loss"}`;
//                 amountVal = isWin ? card?.winnAmount : card?.Game_Ammount;
//                 isPositive = isWin;
//                 closingBal =
//                   card?.Winner?.id === user?._id
//                     ? card?.Winner_closingbalance
//                     : card?.Loser_closingbalance;
//                 dateStr = card?.createdAt;
//               } else {
//                 typeText = `Type : ${card?.Req_type || "Transaction"}`;
//                 statusText = card?.status
//                   ? card?.status.toUpperCase()
//                   : "SUCCESS";
//                 msgText = card?.txn_msg || "";
//                 amountVal = card?.amount;
//                 isPositive =
//                   card?.Req_type === "deposit" || card?.Req_type === "bonus";
//                 closingBal = card?.closing_balance;
//                 dateStr = card?.createdAt;
//               }

//               const formattedDate = dateFormat(dateStr);

//               return (
//                 <div
//                   key={card?._id || index}
//                   style={{
//                     backgroundColor: "#ffffff",
//                     color: "#000000",
//                     borderRadius: "12px",
//                     padding: "15px 20px",
//                     marginBottom: "15px",
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//                     border: "1px solid #e0e0e0",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                     }}
//                   >
//                     {/* LEFT COLUMN: Type, Status, Message */}
//                     <div>
//                       <div
//                         style={{
//                           fontSize: "16px",
//                           fontWeight: "600",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         {typeText}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "14px",
//                           color: "#333",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         Status:{" "}
//                         <span style={{ fontWeight: "600" }}>{statusText}</span>
//                       </div>
//                       {msgText && (
//                         <div style={{ fontSize: "14px", color: "#d9534f" }}>
//                           {msgText}
//                         </div>
//                       )}
//                     </div>

//                     {/* RIGHT COLUMN: Amount, Closing Balance, Date & Time */}
//                     <div style={{ textAlign: "right" }}>
//                       <div
//                         style={{
//                           fontSize: "18px",
//                           fontWeight: "700",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "flex-end",
//                           gap: "4px",
//                         }}
//                       >
//                         <span
//                           style={{ color: isPositive ? "#28a745" : "#d9534f" }}
//                         >
//                           {isPositive ? "(+) ₹" : "(-) ₹"}
//                         </span>
//                         <span
//                           style={{ color: isPositive ? "#28a745" : "#d9534f" }}
//                         >
//                           {amountVal}
//                         </span>
//                       </div>

//                       {closingBal !== undefined && closingBal !== null && (
//                         <div
//                           style={{
//                             fontSize: "12px",
//                             color: "#666",
//                             marginTop: "2px",
//                           }}
//                         >
//                           closing balance :{closingBal}
//                         </div>
//                       )}

//                       <div
//                         style={{
//                           fontSize: "12px",
//                           color: "#555",
//                           marginTop: "6px",
//                           lineHeight: "1.2",
//                         }}
//                       >
//                         <div>{formattedDate.split(",")[0]}</div>
//                         <div>{formattedDate.split(",")[1]}</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })
//           )}
//         </div>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Newhistory;


import React, { useState, useEffect, useRef } from "react";
import css from "../css/gamehis.module.css";
import ReactPaginate from "react-paginate";
import axios from "axios";
import socket from "../Components/socket";
import Rightcontainer from "../Components/Rightcontainer";
import { BsFillEyeFill } from "react-icons/bs";
import { apiRequest } from "../../apiService/allApi";
import { toast } from "react-toastify";

const Newhistory = ({ TicketList, Conversation }) => {
  // BASE URL
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  var baseUrl =
    nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("Wallet"); // 'Wallet', 'Game', 'Penalty', 'Bonus'

  let limit = 50;
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true); // Loader fix for initial blink

  // Data states
  const [walletData, setWalletData] = useState([]);
  const [gameData, setGameData] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);

  // Fetch User & Data
  const role = async () => {
    socket.emit("getprofile");
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      setUser(res.data);
      fetchAllData(res.data._id);
    } catch (e) {
      setIsLoading(false);
      setIsInitialLoad(false);
    }
  };

  const fetchAllData = async (userId) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    setIsLoading(true);
    try {
      // 1. Fetch Wallet / Deposit / Withdraw / Transactions
      const resWallet = await apiRequest(
        `temp/deposite/${userId}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );
      if (resWallet?.data) {
        setWalletData(resWallet.data.ress || []);
        setNumberOfPages(resWallet.data.totalPages || 0);
      }

      // 2. Fetch Game History
      const resGame = await apiRequest(
        `game/history/user/${userId}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );
      if (resGame?.data?.data) {
        let gameHis = [];
        resGame.data.data.forEach((ele) => {
          if (
            ele.Status === "completed" ||
            ele.Status === "cancelled" ||
            ele.Status === "conflict"
          ) {
            gameHis.push(ele);
          }
        });
        setGameData(gameHis);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      setIsInitialLoad(false);
    }
  };

  useEffect(() => {
    role();
    //eslint-disable-next-line
  }, [pageNumber]);

  const dateFormat = (e) => {
    if (!e) return "";
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
    });
    const time = date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
      .toLowerCase();
    return `${newDate}, ${time}`;
  };

  // Filter Data based on Active Tab
  const getFilteredData = () => {
    if (activeTab === "Wallet") {
      return walletData.filter(
        (card) => card?.Req_type === "deposit" || card?.Req_type === "withdraw",
      );
    } else if (activeTab === "Game") {
      return gameData;
    } else if (activeTab === "Penalty") {
      return walletData.filter((card) => card?.Req_type === "penalty");
    } else if (activeTab === "Bonus") {
      return walletData.filter((card) => card?.Req_type === "bonus");
    }
    return [];
  };

  const currentList = getFilteredData();

  return (
    <div style={{ display: "flex", width: "100%", minHeight: "100vh", backgroundColor: "#ffffff" }}>
      <div
        className="leftContainer mt-4 pt-5 bgbox"
        style={{
          flex: 1,
          backgroundColor: "#ffffff",
          color: "#000000",
          paddingTop: "0px",
          minHeight: "100vh",
        }}
      >
        {/* TABS HEADER SECTION */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            padding: "20px 15px",
            overflowX: "auto",
            backgroundColor: "#ffffff",
          }}
        >
          {["Wallet", "Game", "Penalty", "Bonus"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                padding: "10px 15px",
                borderRadius: "35px",
                border: "1px solid #d1d5db",
                backgroundColor: activeTab === tab ? "#000000" : "#ffffff",
                color: activeTab === tab ? "#ffffff" : "#000000",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                outline: "none",
                boxShadow: activeTab === tab ? "0 4px 12px rgba(0,0,0,0.15)" : "0 1px 3px rgba(0,0,0,0.05)",
                transition: "all 0.2s ease",
              }}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* CONTENT CONTAINER */}
        <div
          className="Orher_page_main_section bgbox"
          style={{
            backgroundColor: "#ffffff",
            color: "#000000",
            paddingBottom: "10vh",
            padding: "15px",
          }}
        >
          {isInitialLoad ? (
            <div className="text-center py-5">
              <div className="loaderReturn" style={{ zIndex: "99" }}>
                <img
                  src={"/images/LandingPage_img/loader1.gif"}
                  style={{ width: "80px" }}
                  alt="loading"
                />
              </div>
            </div>
          ) : currentList.length === 0 ? (
            <div className="text-center not_found_box_main mt-5">
              <img
                src="./images/not-found.gif"
                alt="no data"
                style={{ width: "120px" }}
              />
              <div className="mt-3">
                <h3 className="font-weight-bold" style={{ color: "#333" }}>No {activeTab} History</h3>
                <p style={{ color: "#666" }}>You have no {activeTab.toLowerCase()} history yet.</p>
              </div>
            </div>
          ) : (
            currentList.map((card, index) => {
              const isGameCard = activeTab === "Game";

              let typeText = "";
              let statusText = "";
              let msgText = "";
              let amountVal = "";
              let isPositive = false;
              let closingBal = "";
              let dateStr = "";

              // if (isGameCard) {
              //   const isWin =
              //     card?.Status === "completed" &&
              //     card?.Winner &&
              //     card?.Winner?._id === user?._id;
              //   typeText = `Game: ${card?.Room_code || "Room"}`;
              //   statusText = isWin ? "SUCCESS" : card?.Status?.toUpperCase();
              //   msgText = `Game is ${isWin ? "Win" : "Loss"}`;
              //   amountVal = isWin ? card?.winnAmount : card?.Game_Ammount;
              //   isPositive = isWin;
              //   closingBal =
              //     card?.Winner?.id === user?._id
              //       ? card?.Winner_closingbalance
              //       : card?.Loser_closingbalance;
              //   dateStr = card?.createdAt;
              // } else {
              //   typeText = `Type : ${card?.Req_type || "Transaction"}`;
              //   statusText = card?.status
              //     ? card?.status.toUpperCase()
              //     : "SUCCESS";
              //   msgText = card?.txn_msg || "";
              //   amountVal = card?.amount;
              //   isPositive =
              //     card?.Req_type === "deposit" || card?.Req_type === "bonus";
              //   closingBal = card?.closing_balance;
              //   dateStr = card?.createdAt;
              // }
              
if (isGameCard) {
  const gameStatus = card?.Status?.toLowerCase();

  const isWin =
    gameStatus === "completed" &&
    (card?.Winner?._id === user?._id ||
      card?.Winner?.id === user?._id);

  const isCancelled = gameStatus === "cancelled";
  const isConflict = gameStatus === "conflict";

  typeText = `Game: ${card?.Room_code ?? "Room"}`;

  statusText = isCancelled
    ? "CANCELLED"
    : isConflict
      ? "CONFLICT"
      : gameStatus === "completed"
        ? isWin
          ? "SUCCESS"
          : "COMPLETED"
        : gameStatus?.toUpperCase() || "UNKNOWN";

  // Cancelled game ko Loss nahi dikhana
  msgText = isCancelled
    ? "Game is Cancelled"
    : isConflict
      ? "Game is in Conflict"
      : gameStatus === "completed"
        ? `Game is ${isWin ? "Win" : "Loss"}`
        : "";

  amountVal = isWin ? card?.winnAmount : card?.Game_Ammount;

  // Cancelled/conflict game ko loss ki tarah red amount mat dikhao
  isPositive = isWin;

  closingBal =
    card?.Winner?._id === user?._id ||
    card?.Winner?.id === user?._id
      ? card?.Winner_closingbalance
      : card?.Loser_closingbalance;

  dateStr = card?.createdAt;
} else {
  typeText = `Type : ${card?.Req_type || "Transaction"}`;
  statusText = card?.status
    ? card.status.toUpperCase()
    : "SUCCESS";
  msgText = card?.txn_msg || "";
  amountVal = card?.amount;
  isPositive =
    card?.Req_type === "deposit" ||
    card?.Req_type === "bonus";
  closingBal = card?.closing_balance;
  dateStr = card?.createdAt;
}


              const formattedDate = dateFormat(dateStr);

              return (
                <div
                  key={card?._id || index}
                  style={{
                    backgroundColor: "#f7f9fa", // Exact off-white/light-grey card background as in screenshot
                    color: "#000000",
                    borderRadius: "16px",
                    padding: "18px 20px",
                    marginBottom: "16px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    {/* LEFT COLUMN: Type, Status, Message */}
                    <div>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#111827",
                          marginBottom: "4px",
                        }}
                      >
                        {typeText}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#4b5563",
                          marginBottom: "4px",
                        }}
                      >
                        Status:<span style={{ fontWeight: "600", color: "#111827" }}>{statusText}</span>
                      </div>
                      {msgText && (
                        <div style={{ fontSize: "14px", color: "#ef4444", fontWeight: "500" }}>
                          {msgText}
                        </div>
                      )}
                    </div>

                    {/* RIGHT COLUMN: Amount, Closing Balance, Date & Time */}
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          gap: "2px",
                        }}
                      >
                        <span
                          style={{ color: isPositive ? "#10b981" : "#1f2937" }}
                        >
                          {isPositive ? "(+) ₹" : "(-) ₹"}
                        </span>
                        <span
                          style={{ color: isPositive ? "#10b981" : "#1f2937" }}
                        >
                          {amountVal}
                        </span>
                      </div>

                      {closingBal !== undefined && closingBal !== null && (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#6b7280",
                            marginTop: "2px",
                          }}
                        >
                          closing balance :{closingBal}
                        </div>
                      )}

                      <div
                        style={{
                          fontSize: "12px",
                          color: "#6b7280",
                          marginTop: "6px",
                          lineHeight: "1.3",
                        }}
                      >
                        <div>{formattedDate.split(",")[0]}</div>
                        <div>{formattedDate.split(",")[1]}</div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Newhistory;
